export const WAITLIST_FORM_ID = '9543c645-08f7-42b5-97ad-8fe062963395';

export const WAITLIST_FORM_NAMESPACE = 'wix.bookings.appointment.waitlist';
